import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import {GetLanguage} from '../../actions/index';

class Language extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetLanguage(token)
    }
    render() {
        return (
            <div className="dashboard-wrapper">
                
                <div className="dashboard-title clearfix"><p className="pull-left">Languages</p></div>
                <div>
                    <div className="col-md-12">
                        <Link to={"language/all"} className="white-block common-list second clearfix">
                            <p>All languages</p>
                            <p>{this.props.lang.count ? this.props.lang.count['langs.language'] : ''} languages</p>
                        </Link>
                        <Link to={"language/learning"} className="white-block common-list second clearfix">
                            <p>Learning languages</p>
                            <p>{this.props.lang.count ? this.props.lang.count['langs.foreignlanguage'] : ''} languages</p>
                        </Link>
                        <Link to={"language/interface"} className="white-block common-list second clearfix">
                            <p>Interface languages</p>
                            <p>{this.props.lang.count ? this.props.lang.count['langs.baselanguage'] : ''} languages</p>
                        </Link>
                    </div>
                </div>
                <div className="clearfix"></div>
            </div>
        );
    }
}

function  mapStateToProps(state) {
    return{
        lang: state.lang
    }
}
export default connect(mapStateToProps, {GetLanguage})(Language);


// WEBPACK FOOTER //
// ./src/components/language/language_list.js